import { render } from "./ProductListing.vue?vue&type=template&id=2318fa20"
import script from "./ProductListing.vue?vue&type=script&lang=js"
export * from "./ProductListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__